export default {
  methods: {
    formatDate(date) {
      const splittedDate = date.split('-');
      const month = splittedDate[0];
      splittedDate[0] = splittedDate[1];
      splittedDate[1] = month;
      for (let i = 0; i < 2; i += 1) {
        if (splittedDate[i].length === 1) {
          splittedDate[i] = `0${splittedDate[i]}`;
        }
      }
      return splittedDate.join('-');
    },
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/mixins/format_date.js